<template>
  <div class="big">
    <div class="page_title">关联用户（业务员）</div>
    <div style="padding:20px;">
      <div class="container">
        <div class="filterBox flex wrap">
          <div class="box flex">
            <div class="label">员工号</div>
            <el-input
              v-model="recommender_code"
              style="width:130px"
              @change="search"
            />
          </div>
          <div class="box flex">
            <div class="label">员工姓名</div>
            <el-input
              v-model="recommender_name"
              style="width:130px"
              @change="search"
            />
          </div>
          <div class="box flex">
            <div class="label">员工手机号</div>
            <el-input
              v-model="recommender_phone"
              style="width:130px"
              @change="search"
            />
          </div>
          <div class="box flex">
            <div class="label">用户昵称(被关联)</div>
            <el-input
              v-model="nick_name"
              style="width:130px"
              @change="search"
            />
          </div>
          <div class="box flex">
            <div class="label">手机号(被关联)</div>
            <el-input
              v-model="phone"
              style="width:130px"
              @change="search"
            />
            <el-button
              type="info"
              class="search-button"
              @click="search"
            >查询</el-button>
          </div>
        </div>
        <div style="border: solid 1px #c9cbd6;">
          <el-table
            ref="multipleTable"
            :data="tableData"
            tooltip-effect="dark"
            style="width: 100%;min-width:1200px;"
            :header-cell-style="{background:'#F5F5F5'}"
            :span-method="objectSpanMethod"
          >
            <el-table-column
              prop="recommender_phone"
              label="员工手机号"
            />
            <el-table-column
              prop="recommender_code"
              label="员工号"
            />
            <el-table-column
              prop="recommender_name"
              label="员工姓名"
            />

            <el-table-column
              label="用户昵称（被关联）"
              prop="nick_name"
              class-name="border-column"
              align="center"
            />
            <el-table-column
              label="手机号（被关联）"
              align="center"
            >
              <template slot-scope="scope">
                <span v-if="scope.row.phone!='查看更多'">{{scope.row.phone}}</span>
                <span
                  class="main-color"
                  style="cursor:pointer"
                  v-if="scope.row.phone=='查看更多'"
                  @click="showMore(scope.row.recommender_code)"
                  :disabled="
          module_id_array[0] ? !module_id_array.includes('947') : false
        "
                >查看更多</span>
              </template>
            </el-table-column>
            <el-table-column
              label="操作"
              class-name="border-column"
              align="center"
            >
              <template slot-scope="scope">
                <el-button
                  type="text"
                  @click="toEditLog(scope.row)"
                  :disabled="module_id_array[0]?!module_id_array.includes('947'):false"
                >编辑</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="pagesize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalNum"
            style="margin:20px 0"
          ></el-pagination>
        </div>
      </div>
    </div>
    <!-- 更多邀请人弹窗 -->
    <el-dialog
      title="更多被邀请人"
      :visible.sync="extraShow"
      width="700px"
      style="text-align:left"
      center
    >
      <div style="padding:20px">
        <div style="border: solid 1px #c9cbd6;">
          <el-table
            :data="extraData"
            tooltip-effect="dark"
            style="width: 100%;"
            height="500px"
            :header-cell-style="{background:'#F5F5F5'}"
          >
            <el-table-column
              prop="nick_name"
              label="用户昵称（被邀请）"
              align="center"
            />
            <el-table-column
              prop="phone"
              label="手机号（被邀请）"
              align="center"
            />
            <el-table-column
              label="是否登录APP"
              align="center"
            >
              <template slot-scope="scope">
                <span v-if="scope.row.item_id>0">是</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      recommender_code: '',
      recommender_name: '',
      recommender_phone: '',
      nick_name: '',
      phone: '',
      currentPage: 1,
      pagesize: 10,
      totalNum: 0,
      tableData: [],
      extraShow: false,
      extraData: []
    };
  },
  activated() {
    this.getList();
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
    admin_id() {
      return this.$store.state.login.userInfo.admin_id;
    }
  },
  methods: {
    //获取列表
    getList() {
      let data = {
        nick_name: this.nick_name,
        phone: this.phone,
        recommender_code: this.recommender_code,
        recommender_name: this.recommender_name,
        recommender_phone: this.recommender_phone,
        page: this.currentPage,
        pageNumber: this.pagesize
      };
      this.axios
        .post('platform/Activity/getRelationUserList', data)
        .then((res) => {
          this.totalNum = res.data.total;
          this.tableData = res.data.list;
          this.fomartList(res.data.list);
        });
    },
    search() {
      this.currentPage = 1;
      this.getList();
    },
    //每页数据的条数
    handleSizeChange(size) {
      this.pagesize = size;
      this.getList();
    },
    //当前第几页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    //格式化获取的推荐人列表
    fomartList(list) {
      let arr = [];
      list.forEach((ele) => {
        if (ele.item_list.length > 0) {
          let children = [];
          ele.item_list.forEach((info, index) => {
            let obj = {
              recommender_phone: ele.phone,
              recommender_code: ele.recommender_code,
              recommender_name: ele.recommender_name,
              user_id: info.user_id,
              nick_name: info.nick_name,
              phone: info.phone
            };
            if (index <= 9) {
              arr.push(obj);
              children.push(obj);
            } else {
              children.push(obj);
            }
          });
          if (ele.item_list.length > 10) {
            let obj = {
              recommender_code: ele.recommender_code,
              recommender_code: ele.recommender_code,
              recommender_name: ele.recommender_name,
              user_id: ele.user_id,
              nick_name: ele.nick_name,
              phone: '查看更多',
              children: children
            };
            arr.push(obj);
          }
        } else {
          ele.recommender_phone = ele.phone;
          ele.user_id = '';
          ele.nick_name = '';
          ele.phone = '';
          arr.push(ele);
        }
      });
      this.tableData = arr;
    },
    //合并表格
    objectSpanMethod({ row, rowIndex, columnIndex }) {
      let num = 0;
      if (
        columnIndex == 0 ||
        columnIndex == 1 ||
        columnIndex == 2 ||
        columnIndex == 5
      ) {
        this.tableData.forEach((ele) => {
          if (row.recommender_code == ele.recommender_code) {
            num++;
          }
        });
      }
      if (num == 1) {
        return {
          rowspan: 1,
          colspan: 1
        };
      } else if (num > 1) {
        if (
          this.tableData[rowIndex - 1] &&
          this.tableData[rowIndex].recommender_code ==
            this.tableData[rowIndex - 1].recommender_code
        ) {
          return {
            rowspan: 0,
            colspan: 0
          };
        } else {
          return {
            rowspan: num,
            colspan: 1
          };
        }
      }
    },
    //超过10个时查看更多
    showMore(recommender_code) {
      let data = {
        recommender_code: recommender_code,
        page: 1,
        pageNumber: 10000
      };
      this.axios
        .post('platform/Activity/getRelationUserMoreList', data)
        .then((res) => {
          this.extraData = res.data.list;
          this.extraShow = true;
        });
    },
    toEditLog(row) {
      this.$router.push({
        path: 'relationdetail',
        query: {
          recommender_phone: row.recommender_phone,
          recommender_code: row.recommender_code,
          recommender_name: row.recommender_name
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.text_over {
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  width: 80px;
  text-overflow: ellipsis;
}
.container {
  padding: 20px;
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}
.el-table__expand-icon--expanded {
  display: none;
}
.el-table .expanded {
  background-color: #f9f8ee;
}
.filterBox {
  margin-bottom: 10px;
  align-items: center;
  .box {
    margin-right: 20px;
    margin-bottom: 10px;
    align-items: center;
    .label {
      margin-right: 10px;
    }
  }
  .search-button {
    background-color: #eceff2;
    color: #747981;
    margin-left: 10px;
  }
}
</style>
<style lang="scss">
.border-column {
  border-left: 1px solid #ebeef5;
}
</style>